import React from 'react';

export default function Card({ children }) {
  return <div className="card-body vehicle-card-body">{children}</div>;
}
